import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import { Actions, ActionTypes } from '../../store/categories/categories.actions';
import { StateInterface } from '../../store/state.model';
import { HeadersHelper, ItemsHelper } from '../../helpers';
import { getState, tassign } from '../../tools';

import 'rxjs/Rx';

@Injectable()

/**
 * Class representing the Categories service.
 */
export class CategoriesService {

	/**
	 * Constructor.
	 * @param {string} apiEndPoint
	 * @param {Http} http
	 * @param {Store} store
	 * @return {void}
	 */
	constructor(
		@Inject('ApiEndpoint') private apiEndpoint: string,
		private http: Http,
		private store: Store<StateInterface>) {
	}

	/**
	 * Retrieve categories data from server and dispatch action
	 * to update the store accordingly.
	 * @return {Observable}
	 */
	hydrateCategories(): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		return this.http.get(`${this.apiEndpoint}category`, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Create a new category
	 * @param  {DescrNL:string,DescrEN:string}  names [description]
	 * @return Observable<Response>             [description]
	 */
	createCategory(names: { DescrNL: string, DescrEN: string }): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		return this.http.post(`${this.apiEndpoint}category`, names, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Update a category
	 * @param  {number}                        categoryId [description]
	 * @param  {DescrNL:string,DescrEN:string} names      object containing the NL and EN names
	 * @return Observable<Response>            [description]
	 */
	updateCategory(categoryId: number, names: { DescrNL: string, DescrEN: string }): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		return this.http.patch(`${this.apiEndpoint}category/` + categoryId, names, HeadersHelper.getOptions(this.store));
	}

	/**
	 * delete a category
	 * @param  {number}                        categoryId [description]
	 * @return Observable<Response>            [description]
	 */
	deleteCategory(categoryId: number): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		return this.http.delete(`${this.apiEndpoint}category/` + categoryId, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Dispatch an action to load categories.
	 * @param {object} result
	 * @return {Actions}
	 */
	loadCategories(result: any): Actions {
		const { categories } = getState(this.store);

		return {
			type: ActionTypes.LOAD_CATEGORIES,
			payload: tassign(categories, {
				items: ItemsHelper.parseItems(result),
				isLoading: false
			})
		};
	}

	/**
	 * Dispatch an action to reset the entire state.
	 * @return {Actions}
	 */
	resetState(): Actions {
		return {
			type: ActionTypes.RESET_STATE
		};
	}

	/**
	 * Dispatch an action to change the state for 'isLoading'.
	 * @param {boolean} to - The new state
	 * @return {Actions}
	 */
	setIsLoading(to: boolean): Actions {
		return {
			type: ActionTypes.SET_IS_LOADING,
			payload: to
		};
	}
}
